import Card from "components/card";
import { MdAccessTime } from "react-icons/md";
import { FaMobileAlt } from "react-icons/fa";

const PlatformUsageMetrics = () => {
  // Simple cumulative metrics that always grow
  const totalHours = 12847; // Total hours all users on mobile
  const avgSessionLength = 2.3; // Average session length in minutes
  const totalAppOpens = 456789; // Total app launches

  // Format large numbers
  const formatNumber = (num: number) => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num.toString();
  };

  return (
    <Card extra="p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-bold text-navy-700 dark:text-white">
          Mobile Platform Usage
        </h3>
        <FaMobileAlt className="text-xl text-brand-500" />
      </div>

      {/* Main metric - Total Hours */}
      <div className="mb-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-2">
          <MdAccessTime className="text-3xl text-brand-500" />
          <div className="text-4xl font-bold text-navy-700 dark:text-white">
            {formatNumber(totalHours)}
          </div>
        </div>
        <p className="text-sm text-gray-600">Total Hours on Platform</p>
      </div>

      {/* Secondary metrics */}
      <div className="grid grid-cols-2 gap-4">
        <div className="text-center p-4 bg-gray-50 dark:bg-navy-800 rounded-lg">
          <p className="text-2xl font-bold text-navy-700 dark:text-white mb-1">
            {avgSessionLength}m
          </p>
          <p className="text-xs text-gray-600">Avg Session</p>
        </div>
        <div className="text-center p-4 bg-gray-50 dark:bg-navy-800 rounded-lg">
          <p className="text-2xl font-bold text-navy-700 dark:text-white mb-1">
            {formatNumber(totalAppOpens)}
          </p>
          <p className="text-xs text-gray-600">App Opens</p>
        </div>
      </div>
    </Card>
  );
};

export default PlatformUsageMetrics;